 export const ActivationStatus = {
     NeverSubscribed: 0,
     InActivationProssess: 1,
     Subscribed: 2,
     UnSubscribedButNotStopped: 3,
     SubscriptionStopped: 4
 }

 export default {
     ActivationStatus
 }
